import { AppUserMenu } from '@/api/models';
import { UserMenuSchema } from './UserPermissionHelper';

interface IGetTourPlayersSettingsProps {
  userMenus: AppUserMenu[];
  userMenuSchema: UserMenuSchema;
}

export interface ITourPlayerSettings {
  canAddPlayer: boolean;
  canEditPlayer: boolean;
}

export const getTourPlayersSettings = ({ userMenus, userMenuSchema }: IGetTourPlayersSettingsProps): ITourPlayerSettings => {
  const userMenuIds = new Set(userMenus.map((m) => m.appMenuId));

  const hasAccess = (menuId?: number) => (menuId ? userMenuIds.has(menuId) : false);

  return {
    canAddPlayer: hasAccess(userMenuSchema.PlayerAdd.appMenuId),
    canEditPlayer: hasAccess(userMenuSchema.PlayerEdit.appMenuId),
  };
};
